import { useEffect, useRef, type ReactNode } from 'react'

interface Props {
  onClose: () => void
  children: ReactNode
}

const SWIPE_THRESHOLD = 80

export function MobileDetailModal({ onClose, children }: Props) {
  const startYRef = useRef<number | null>(null)
  const panelRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    panelRef.current?.scrollTo(0, 0)
  }, [children])

  // body スクロールを防止
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = '' }
  }, [])

  function onTouchStart(e: React.TouchEvent) {
    startYRef.current = e.touches[0].clientY
  }

  function onTouchEnd(e: React.TouchEvent) {
    if (startYRef.current === null) return
    const deltaY = e.changedTouches[0].clientY - startYRef.current
    startYRef.current = null
    if (deltaY > SWIPE_THRESHOLD) onClose()
  }

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-bg-surface">
      {/* スワイプハンドル (タップでも閉じられる) */}
      <div
        className="flex-shrink-0 flex items-center justify-center pt-3 pb-2 cursor-grab active:cursor-grabbing"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onClick={onClose}
        role="button"
        aria-label="閉じる (タップまたは下スワイプ)"
      >
        <div className="w-10 h-1 rounded-full bg-border-strong" aria-hidden="true" />
      </div>

      {/* コンテンツ (swipe-to-close はハンドルのみに限定 — スクロール中に閉じないように) */}
      <div
        ref={panelRef}
        className="flex-1 overflow-y-auto"
      >
        {children}
      </div>
    </div>
  )
}
